<template>
  <div class="payservice">
    <!--项目详情-->
    <div class="order__itemBox">
      <div class="storeList flex_center radius5">
        <div class="storeList__img itemList__img">
          <img :src="order.service_thumb" alt />
        </div>
        <div class="storeList__content">
          <div>{{order.servicetitle}}</div>
          <div class="col_999 fs_12 mb_5 one">{{order.service_desc}}</div>
          <div class="itemList_price fs_12">
            <span>¥{{order.service_price}} 起</span>
            {{order.service_itemtime}}分钟/次
          </div>
        </div>
      </div>
    </div>

    <div class="order_info">
      <ul> 
        <li class>
          <span>订单编号:</span>
          <span>{{order.ordersn}}</span>
        </li>

        <li class>
          <span>下单时间:</span>
          <span>{{order.createtime}}</span>
        </li>

        <li class>
          <span>订单金额:</span>
          <span class="col_E97620">￥{{order.price}}</span>
        </li>

        <li class>
          <span>订单状态:</span>
          <span v-if="order.status == 0">待付款</span>
          <span v-if="order.status == 1">待接单</span>
          <span v-if="order.status == 2">待服务</span>
          <span v-if="order.status == 3">已完成</span>
          <span v-if="order.status == -1">已关闭</span>
          <span v-if="order.status == 4">已关闭</span>
        </li>

        <li class>
          <span class="distance_text">{{order.distance_text}}</span>
          <span class="col_5E5E5E">{{order.distance_service}}</span>
        </li>
      </ul>
    </div>

    <div class="order_info">
      <ul class="store_box">
        <li class>
          <span>服务门店:</span>
          <span>{{store.storename}}</span>
        </li>

        <li class>
          <span>服务人数:</span>
          <span>{{order.total}}位</span>
        </li>

        <!-- <li class>
          <span>服务床位:</span>
          <span>1号床位</span>
        </li>-->

        <li class v-for="(t_item,t_index) in tech" :key="t_index">
          <span>服务技师:</span>
          <span>
            {{t_item.name}}
          </span>
          <a v-if="t_item.refuse==2" class="tech_none">（拒绝接单）</a>
          <a v-if="t_item.refuse==1||t_item.refuse==3" class="">（已接单）</a>
          <span v-if="t_item.refuse==2&&t_item.choose_tech==0&&t_item.is_choose==1" class='technician_status' @click="choose_tech(t_item.level_id,t_item.id)">重新选择</span>
        </li>

        <li class>
          <span>服务时间:</span>
          <span>{{order.starttime}}</span>
        </li>

        <li class>
          <span>联系人:</span>
          <span>{{order.realname}}</span>
        </li>

        <li class>
          <span>手机号:</span>
          <span>{{order.mobile}}</span>
        </li>
        <li class="none_order" v-for="(tech_no_item,tech_no_index) in tech_no_order" :key="tech_no_index">
          <span></span> <span>技师{{tech_no_item.tech_name}}拒绝接单，原因：{{tech_no_item.tech_refuse}}</span>
        </li>
      </ul>

      <div class="btn_box">
        <button class="cancel_btn" @click="cancel"  v-if="(order.status==0||order.status==1||order.status==2)&&order.is_cancel==1">取消订单</button>
        <router-link :to="{path: '/checkservice',query: {orderid:order.id}}" class="pay_btn" v-if="order.status==2">确认服务</router-link>
        <button class="pay_btn" v-if="order.status==0&&order.is_pay==1" @click="pay()">立即付款</button>
        <button class="pay_btn refund"  v-if="order.status==3&&order.is_refund==1"  @click="refund()">退款</button>
        <router-link :to="{path:'/comment', query:{orderid:order.id}}" class="pay_btn" v-if="order.status==3 && order.is_comment != 1">待评价</router-link>
      </div>
    </div>

    <van-popup v-model="cancelrs_show" closeable position="bottom" class="popup" v-if="order.status==0||order.status==1||order.status==2">
      <p class="cancel_label">取消订单</p>

      <!-- 需写判断（暂未添加） -->
      <div class="time_tip flex_center">
        <span class="iconfont icon-tishi"></span>
       {{order.refuse_toast}}
      </div>

      <p class="respon_label">请选择取消订单原因</p>

      <van-radio-group v-model="radio">
        <van-cell-group>
          <van-cell title="时间冲突" clickable @click="radio = '0'">
            <van-radio slot="right-icon" name="0" />
          </van-cell>
          <van-cell title="不想服务了" clickable @click="radio = '1'">
            <van-radio slot="right-icon" name="1" />
          </van-cell>
          <van-cell title="其他原因" clickable @click="radio = '2'">
            <van-radio slot="right-icon" name="2" />
          </van-cell>
        </van-cell-group>
      </van-radio-group>

      <div class="other" v-if="radio=='2'">
        <!-- <input type="text" v-model="other_refuse" /> -->
        <textarea v-model="other_refuse" ></textarea>
      </div>

      <div class="btn_box">
        <button class="ckcancel_btn" @click="check_cancel">确认取消</button>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "orderDetails",
  components: {},
  data() {
    return {
      orderid: 0,
      cancelrs_show: false,
      radio: "0",
      order: [],
      store: [],
      tech: [],
      other_refuse: "",
      tech_no_order:[],
    };
  },
  created() {
    if (this.$route.query.cancelrs_show) {
      this.cancelrs_show = this.$route.query.cancelrs_show;
    }
    this.orderid = this.$route.query.orderid;
    this.init();
  },
  methods: {
    init() {
      this.order_detail();
    },
    order_detail() {
      if (this.orderid != 0) {
        this.axios({
          url: this.api.order.order_detail, 
          data: { order_id: this.orderid }
        }).then(res => {
          if (res.error === 0) {
            this.order = res.data.order;
            this.store = res.data.store;
            this.tech = res.data.tech;
            this.tech_no_order  =res.data.tech_no_order;
          }
        });
      } else {
      }
    },
    pay(){
        this.axios({
            url: this.api.order.pay_order,
            data:{order_id:this.order.id}
        }).then((res) => {
          var that  = this;
            if (res.error === 0) {
                 //调用微信支付
                  this.wx.wxPay({
                     url:this.api.wxpay.AppoinTment,
                     data:{
                       id:res.id,
                       ordersn:res.ordersn
                     }
                  },()=>{
                    that.$router.push({path:'order',query:{}});
                  });

              }

        });

    },
    cancel() {
      this.cancelrs_show = true;
    },
    check_cancel() {
      let refuse = "";
      if (this.radio == "0") {
        refuse = "时间冲突";
      }
      if (this.radio == "1") {
        refuse = "不想服务了";
      }
      if (this.radio == "2") {
        refuse = this.other_refuse;
      }

      this.axios({
        url: this.api.order.cancel_order, 
        data: { refuse: refuse, order_id: this.orderid }
      }).then(res => {
        if (res.error === 0) {
          this.$toast({
            message: "取消成功",
            type: "success",
            onClose: () => {
              this.$router.push("/order");
            }
          });
        }
      });
    },
    refund(){

      this.axios({
        url: this.api.order.refund_order, 
        data: { order_id: this.orderid }
      }).then(res => {
        if (res.error === 0) {
          this.$toast({
            message: "退款成功",
            type: "success",
            onClose: () => {
              location.reload() 
            }
          });
        }
      });
    },
    choose_tech(level_id,tech_id){
      if(!level_id){
        this.$toast("请选择技师等级");
        return;
      }
      this.$router.push({'path':'/chooseTech','query':{'level_id':level_id,'order_id':this.orderid,'tech_id':tech_id}});
    },
  }
};
</script>
<style scoped>
@import "../../assets/css/store.css"; /*门店样式*/
@import "../../assets/css/item.css"; /*服务项目*/
.distance_text{
      width: auto !important;
    margin-right: 1rem;
}
.refund{
    border-color: #c8c9cc!important;
    color: #7d7e80!important;
}
.order__itemBox {
  background: #45b9bc;
  padding: 0.75rem 0.5rem;
}
.storeList {
  margin-bottom: 0;
}

.technician_status {
    text-align: right;
    float: right;
    color: white !important;
    background-color: #45b9bc;
    border-radius: 5px;
    padding: 0.2rem 0.5rem;
    width: auto !important;
    font-size: 0.6rem;
    margin-top: -0.2rem;
}
.order_info {
  margin-top: 0.5rem;
  padding: 0.5rem 0.75rem;
  font-size: 0.7rem;
  color: #4b4d4d;
  background-color: white;
}
.order_info span:last-child {
  color: #929393;
}
.order_info li {
  padding: 0.25rem 0;
}
.order_info li span:first-child {
  width: 25%;
  display: block;
  float: left;
}
.order_info li span:last-child {
  width: 100%;
  display: block;
}
.col_E97620 {
  color: #e97620 !important;
}
.store_box {
  padding-bottom: 1.25rem;
  border-bottom: 1px solid #eee;
}
.btn_box {
  margin: 2rem 0;
  text-align: center;
}
.cancel_btn {
  border-radius: 5px;
  border: 1px solid #a0a0a0;
  font-size: 0.8rem;
  color: #7b7979;
  padding: 0.5rem 1.3rem;
  margin: 0 0.5rem;
}
.pay_btn {
  border-radius: 5px;
  border: 1px solid #45b9bc;
  font-size: 0.8rem;
  color: #45b9bc;
  padding: 0.5rem 1.3rem;
  margin: 0 0.5rem;
}
.popup {
}
.cancel_label {
  padding: 1rem 0;
  font-size: 0.9rem;
  color: #434343;
  text-align: center;
}
.time_tip {
  background-color: #effbfb;
  color: #45b9bc;
  font-size: 0.6rem;
  padding: 0.25rem 0.75rem;
}
.icon-tishi {
  padding-top: 0.2rem;
}
.respon_label {
  font-size: 0.7rem;
  color: #989696;
  padding: 1rem 0.75rem 0.5rem;
}
.other {
  margin: 0.5rem 0.75rem;
  border: 1px solid #eee;
}
.other input {
  width: 100%;
  font-size: 0.75rem;
}
/*.van-radio-group {*/
/*  padding: 0 0.75rem;*/
/*  font-size: 0.7rem;*/
/*  color: #595757;*/
/*}*/
.van-radio__icon {
  height: 1rem;
}
.ckcancel_btn {
  background-color: #45b9bc;
  color: white;
  border-radius: 4px;
  padding: 0.5rem 0;
  width: 70%;
}
.col_5E5E5E {
  color: #5e5e5e !important;
}
.none_order span{
  color: crimson !important
}
.tech_none{
  color: crimson !important
}
</style>



// WEBPACK FOOTER //
// src/views/order/orderDetails.vue